import Icon from '@atoms/Icon/Icon';
import useMediaQuery from '@utils/hooks/useMediaQuery';
import classNames from 'classnames';

interface Props {
  readonly isActive: boolean;
  readonly onClick: () => void;
  readonly icon: string;
  readonly label: string;
  readonly rightDesktopPadding?: number;
}

const GalleryTabButton = ({
  isActive,
  onClick,
  icon,
  label,
  rightDesktopPadding = 15,
}: Props) => {
  const isMobile = useMediaQuery(1024);

  return (
    <button
      tabIndex={0}
      onClick={onClick}
      className={classNames(
        'flex-start group flex flex-row items-center rounded-[40px] border border-transparent bg-grey-600 py-[10px] transition-colors hover:border-yellow max-lg:px-5 lg:pl-5',
        {
          'border-yellow text-yellow': isActive,
        }
      )}
      style={{
        ...(isMobile
          ? {}
          : {
              paddingRight: rightDesktopPadding,
            }),
      }}
    >
      <div className="flex items-center justify-center pr-2.5">
        <Icon
          name={icon}
          colorClassName="transition-colors group-hover:text-yellow"
        />
      </div>

      {label && (
        <div
          key={`tab-${label}`}
          className={classNames(
            'flex w-auto flex-col items-center transition-colors group-hover:text-yellow',
            isActive ? 'text-yellow' : 'text-grey-500'
          )}
        >
          <div className="body-three whitespace-nowrap">{label}</div>
        </div>
      )}
    </button>
  );
};

export default GalleryTabButton;
